import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import LeftArrow from 'material-ui/svg-icons/navigation/arrow-back'
import ContactsTable from './ContactsTable'
import AddContactDialog from './CustomerInterfaces/AddContactDialog'
import EditContactDialog from './CustomerInterfaces/EditContactDialog'
import CustomerSummary from './CustomerSummary/SummarySection'
import CircularProgress from 'material-ui/CircularProgress'
import JobScreen from 'schedule/common/JobScreen'

import { connect } from 'react-redux'
import * as firebase from 'firebase'
import _ from 'lodash'

class Contacts extends React.Component {

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    customerId: PropTypes.string.isRequired,
    onBackClicked: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      customer: {},
      contacts: [],
      contactChosen: {},
      showContactAddDialog: false,
      showContactEditDialog: false
    }
  }

  componentDidMount() {
    this.attachListener(this.props)
  }

  componentWillUnmount() {
    this.detachListener(this.props)
  }

  attachListener = props => {
    if (props.customerId){
      firebase.database()
        .ref(`customers/${props.teamId}`)
        .orderByKey()
        .equalTo(props.customerId)
        .on('value', this.onUpdate)
    }
  }

  detachListener = props => {
    firebase.database()
      .ref(`customers/${props.teamId}`)
      .orderByKey()
      .equalTo(props.customerId)
      .off('value', this.onUpdate)
  }

  onUpdate = (snapshots) => {
    let customer = {}
    const contacts = []
    //only have one value
    snapshots.forEach(snapshot => customer = snapshot.val())

    _.keys(customer.contactsList).forEach(id => {
      const contact = customer.contactsList[id]
      contacts.push(contact)
    })
    contacts.sort((a,b) => a.contactName > b.contactName ? 1 : -1)
    this.setState({
      contacts,
      customer,
      loading: false,
      contactChosen: contacts[0]
    })
  }

  handleAddNewContact = () => {
    this.setState({ showContactAddDialog: false })
  }

  handleAddContactRequest = () => {
    this.setState({ showContactAddDialog: !this.state.showContactAddDialog })
  }

  onContactSelection = (contactChosen) => {
    this.setState({ contactChosen })
  }

  onEditRequest = () => {
    this.setState({ showContactEditDialog: !this.state.showContactEditDialog })
  }

  render() {

    let component = null
    if (this.state.loading){
      component = (
        <div style={styles.progress}>
          <CircularProgress thickness={2} />
        </div>
      )
    }
    else {
      component = (
        <div>
          <ContactsTable
            teamId={this.props.teamId}
            customerId={this.props.customerId}
            contacts={this.state.contacts}
            contactIdChosen={this.state.contactChosen.id}
            onContactSelection={this.onContactSelection}
            onEditContact={this.onEditRequest}/>

          <CustomerSummary
            teamId={this.props.teamId}
            customerId={this.props.customerId}
            contactId={this.state.contactChosen.id}/>
        </div>
      )
    }
    return (
      <div style={styles.container}>
        <div style={styles.divider}>
          <div style={styles.back} onClick={this.props.onBackClicked}>
            <LeftArrow/>
          </div>
          <div style={styles.content}>
            <div style={styles.top}>
              <div style={styles.title}>{this.state.customer.name}</div>
              <FlatButton
                style={{border: '1px solid #e2e2e2', marginLeft: 8}}
                labelStyle={{ color: '#4d6f7f' }}
                label='Create new contact'
                backgroundColor='#fff'
                onTouchTap={this.handleAddContactRequest}/>
            </div>
            { component }
          </div>
        </div>
        <AddContactDialog
          open={this.state.showContactAddDialog}
          teamId={this.props.teamId}
          customerId={this.props.customerId}
          onSave={this.handleAddNewContact}
          onCloseRequest={this.handleAddContactRequest}/>
        <EditContactDialog
          open={this.state.showContactEditDialog}
          customerId={this.props.customerId}
          teamId={this.props.teamId}
          item={this.state.contactChosen}
          onSave={this.onEditRequest}
          onCloseRequest={this.onEditRequest}/>
        <JobScreen/>
      </div>
    )
  }

}

const styles = {
  container: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto'
  },
  divider: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1
  },
  back: {
    marginTop: 64,
    marginLeft: 80,
    cursor: 'pointer'
  },
  content: {
    flex: 1,
    marginLeft: 36,
    marginRight: 140,
    marginTop: 64
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  title: {
    fontSize: 24,
    fontWeight: 400
  },
  zeroItems: {
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id
})

export default connect(mapStateToProps)(Contacts)



// WEBPACK FOOTER //
// ./src/customer/Contacts.js